
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { SkipLinks } from "@/components/ui/skip-links";
import { useAriaLiveRegion } from "@/utils/accessibility";

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { announce, LiveRegion } = useAriaLiveRegion();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    // Announce sidebar state change for screen readers
    announce(sidebarCollapsed ? "Navigation menu expanded" : "Navigation menu collapsed");
  };

  return (
    <div className="flex h-screen bg-background">
      {/* Skip navigation links */}
      <SkipLinks />
      
      {/* Live region for screen reader announcements */}
      <LiveRegion />
      
      {/* Navigation landmark */}
      <nav 
        id="navigation" 
        aria-label="Main navigation"
        role="navigation"
      >
        <Sidebar collapsed={sidebarCollapsed} />
      </nav>
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          toggleSidebar={toggleSidebar} 
          sidebarOpen={!sidebarCollapsed}
          onAnnounce={announce}
        />
        
        {/* Main content landmark */}
        <main 
          id="main-content"
          className="flex-1 overflow-y-auto p-4"
          role="main"
          aria-label="Main content"
          tabIndex={-1}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
